import { videoId } from './video-model';

const requests = new Map();
export function loadVideoMetadata(video) {
  const key = `${video.source}:${video.videoUrl}`;
  if (!requests.has(key)) {
    const url =
      video.source === 1
        ? `https://www.youtube.com/oembed?format=json&url=${encodeURIComponent(`https://www.youtube.com/watch?v=${videoId(video)}`)}`
        : `https://vimeo.com/api/oembed.json?url=${encodeURIComponent(video.videoUrl)}`;
    requests.set(
      key,
      (async () => {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 8000);
        try {
          const response = await fetch(url, { signal: controller.signal });
          if (!response.ok) return {};
          const data = await response.json();
          return {
            title: typeof data.title === 'string' ? data.title : '',
            thumbnail: /^https?:\/\//.test(data.thumbnail_url || '') ? data.thumbnail_url : '',
          };
        } catch {
          return {};
        } finally {
          clearTimeout(timeout);
        }
      })(),
    );
    if (requests.size > 200) requests.delete(requests.keys().next().value);
  }
  return requests.get(key);
}
